import LegalLayout from "@/components/LegalLayout";
import SEO from "@/components/SEO";

export default function Refund() {
  return (
    <>
      <SEO
        title="Refund Policy"
        description="United Techlab's refund policy for professional services engagements and product subscriptions."
        path="/refund"
      />
      <LegalLayout
        eyebrow="> /legal/refund"
        title="Refund Policy"
        lastUpdated="December 2025"
      >
        <p>
          United Techlab is primarily a B2B services and software company.
          Refunds are handled in accordance with the terms of the individual
          engagement. The following general principles apply.
        </p>

        <h2>1. Professional services engagements</h2>
        <ul>
          <li>Services are typically billed on a milestone or time-and-materials basis.</li>
          <li>Fees for work already delivered and accepted are non-refundable.</li>
          <li>Unused pre-paid retainer hours may be refunded on a pro-rata basis, subject to the terms of the master services agreement.</li>
        </ul>

        <h2>2. Product subscriptions</h2>
        <ul>
          <li>Subscription fees are billed in advance for the agreed term (monthly or annual).</li>
          <li>If you cancel during an active term, you retain access until the end of the term; prior payments are non-refundable unless explicitly stated.</li>
          <li>In case of material service failure attributable to United Techlab, we will work with you on a fair remedy, which may include credits or a pro-rata refund.</li>
        </ul>

        <h2>3. Pilots and proofs-of-concept</h2>
        <p>
          Pilots are scoped in writing with explicit deliverables. Fees for
          completed pilot work are non-refundable. If we fail to meet the
          agreed success criteria, we will propose a remedy.
        </p>

        <h2>4. How to request a refund</h2>
        <p>
          Send a written request to{" "}
          <a href="mailto:contact@unitedtechlab.com">contact@unitedtechlab.com</a>{" "}
          including your company name, invoice number, engagement reference,
          and the reason for the request. We respond within 10 business days.
        </p>

        <h2>5. Disputes</h2>
        <p>
          If we cannot reach a mutually acceptable resolution, disputes are
          handled in accordance with the governing law clause of the applicable
          master services agreement.
        </p>
      </LegalLayout>
    </>
  );
}
